// src/homework/homeworkApi.js
// API calls for Homework Mode

import { apiService } from "../apiService";

export async function analyzeProblems(problems) {
  return apiService.makeRequest("/api/homework/analyze", {
    method: "POST",
    body: JSON.stringify({ problems }),
  });
}

export async function solveStep(sessionId, problemId, action, studentInput = null, conversation = null) {
  const body = { session_id: sessionId, problem_id: problemId, action };
  if (studentInput) body.student_input = studentInput;
  if (conversation) body.conversation = conversation;
  return apiService.makeRequest("/api/homework/solve", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function homeworkChat(problemText, message, conversationHistory = []) {
  return apiService.makeRequest("/api/homework/chat", {
    method: "POST",
    body: JSON.stringify({
      problem_text: problemText,
      message,
      conversation_history: conversationHistory,
    }),
  });
}

export async function createHomeworkSession(title, problems, videoJobs) {
  const body = { title, problems };
  if (videoJobs) body.video_jobs = videoJobs;
  return apiService.makeRequest("/api/homework/sessions", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function listHomeworkSessions() {
  return apiService.makeRequest("/api/homework/sessions");
}

export async function getHomeworkSession(sessionId) {
  return apiService.makeRequest(`/api/homework/sessions/${sessionId}`);
}

export async function updateHomeworkSession(sessionId, updates) {
  return apiService.makeRequest(`/api/homework/sessions/${sessionId}`, {
    method: "PATCH",
    body: JSON.stringify(updates),
  });
}

export async function deleteHomeworkSession(sessionId) {
  return apiService.makeRequest(`/api/homework/sessions/${sessionId}`, {
    method: "DELETE",
  });
}
